// to remove free after STARB-1521
type Edition = 'free' | 'standard' | 'premium';

type Task = {
	context?: {
		edition: {
			id: Edition;
		};
		hasPaymentDetails: boolean;
	};
	name: string;
};

export type ProvisionPlanRequest = {
	cloudId: string;
	sourceComponent: string;
	sourceContext: string;
};

export type ProvisionPlanResponse = {
	allowed: boolean;
	context?: {
		status?: ProvisionStatus;
	};
	reasons?: string[];
	tasks: Task[];
};

export type ProvisionStartRequest = {
	cloudId: string;
	locale: string;
	signal?: AbortSignal;
	sourceComponent: string;
	sourceContext: string;
};

export type ProvisionStartNormalizeSeatRequest = {
	cloudId: string;
	signal?: AbortSignal;
};

export type ProvisionStartResponse = {
	allowed: boolean;
	started: boolean;
	tasks: Task[];
};

export type ProvisionStatusRequest = {
	cloudId: string;
};

export type ProvisionStatus =
	| 'PROVISIONING_COMPLETED'
	| 'PROVISIONING_FAILED'
	| 'PROVISIONING_IN_PROGRESS'
	| 'PROVISIONING_ABORTED';

export type ProvisionStatusResponse = {
	context?: {
		onboardingUrl?: string;
		progressUri: string;
	};
	status: ProvisionStatus;
	step: string;
};

export type PollingOptions = {
	initialDelay: number;
	interval: number;
	maxDuration: number;
	signal: AbortSignal;
};

export type ProvisionStartAndTrackResquest = {
	callback: (progress: number, status: ProvisionStatusResponse) => void;
	cloudId: string;
	initialStatus?: ProvisionStatus;
	locale: string;
	pollingOptions: PollingOptions;
	sourceComponent: string;
	sourceContext: string;
};

export type TrackProvisionJobRequest = {
	callback: (progress: number, status: ProvisionStatusResponse) => void;
	cloudId: string;
	initialStatus: ProvisionStatusResponse;
	pollingOptions: PollingOptions;
	tasks: Task[];
};

export type TrackProvisionJobResponse = ProvisionStatusResponse & {
	progress: number;
};

export type PollingState = {
	attempts: number;
	startTime: number;
};

export class PollingTimeoutError extends Error {
	public readonly maxDuration: number;

	constructor(maxDuration: number) {
		super(`Polling timed out after ${maxDuration}ms`);
		this.name = 'PollingTimeoutError';
		this.maxDuration = maxDuration;
	}

	static is(error: unknown): error is PollingTimeoutError {
		return (
			error instanceof PollingTimeoutError ||
			(error instanceof Error && error.name === 'PollingTimeoutError' && 'maxDuration' in error)
		);
	}
}
